import React from 'react';

export const DownloadData = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      //   className={className}
      onClick={disabled ? null : onClick}
    >
      <path
        d="M0 24.5C0 11.2452 10.7452 0.5 24 0.5C37.2548 0.5 48 11.2452 48 24.5C48 37.7548 37.2548 48.5 24 48.5C10.7452 48.5 0 37.7548 0 24.5Z"
        fill="#D9ECFA"
      />
      <g clip-path="url(#clip0_34861_86917)">
        <path
          d="M24 28.5L19 23.5L20.4 22.05L23 24.65V16.5H25V24.65L27.6 22.05L29 23.5L24 28.5ZM18 32.5C17.45 32.5 16.9791 32.3042 16.5875 31.9125C16.1958 31.5208 16 31.05 16 30.5V27.5H18V30.5H30V27.5H32V30.5C32 31.05 31.8041 31.5208 31.4125 31.9125C31.0208 32.3042 30.55 32.5 30 32.5H18Z"
          fill="#003252"
        />
      </g>
      <defs>
        <clipPath id="clip0_34861_86917">
          <rect width="24" height="24" fill="white" transform="translate(12 12.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
